import { Component } from '@angular/core';

@Component({
    templateUrl: './wonbid-help.component.html',
    standalone: false
})
export class WonBidHelpComponent { }
